<div *ngIf="rows.length > 0" class="vote-breakdown">
  <div class="vote-breakdown-title">Individual Votes</div>
  <table class="vote-table">
    <thead>
      <tr>
        <th>Voter</th>
        <th title="Roles & Years of Experience in TWGs (30%)">C1</th>
        <th title="TWG Participation (30%)">C2</th>
        <th title="Other Expertise & Professional Background (30%)">C3</th>
        <th title="Gender Balance (10%)">C4</th>
        <th>Avg</th>
        <th *ngIf="editable"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackByVoter" [class.vote-row--editing]="isEditing(row)">
        <ng-container *ngIf="!isEditing(row)">
          <td class="voter-name">
            {{ row.voter }}
            <span *ngIf="row.edited_by" class="vote-edited-tag" [title]="'Overridden by ' + row.edited_by + (row.edited_at ? ' on ' + (row.edited_at | date:'medium') : '')">
              <i class="fa fa-pencil"></i>
            </span>
          </td>
          <td>{{ row.automatic }}</td>
          <td>{{ row.engagement }}</td>
          <td>{{ row.standardisation }}</td>
          <td>{{ row.gender }}</td>
          <td class="vote-avg">{{ average(row) }}</td>
          <td *ngIf="editable" class="vote-edit-col">
            <button type="button" class="vote-edit-btn" title="Override this vote" (click)="startEdit(row)">
              <i class="fa fa-pencil"></i>
            </button>
          </td>
        </ng-container>

        <ng-container *ngIf="isEditing(row)">
          <td class="voter-name">{{ row.voter }}</td>
          <td>{{ row.automatic }}</td>
          <td>
            <input type="number" min="0" max="10" class="vote-edit-input" [(ngModel)]="editEngagement">
          </td>
          <td>
            <input type="number" min="0" max="10" class="vote-edit-input" [(ngModel)]="editStandardisation">
          </td>
          <td>{{ row.gender }}</td>
          <td class="vote-avg">—</td>
          <td class="vote-edit-col vote-edit-actions">
            <button type="button" class="vote-edit-btn vote-edit-btn--save"
                    [disabled]="editStandardisation == null || editEngagement == null || editStandardisation < 0 || editStandardisation > 10 || editEngagement < 0 || editEngagement > 10"
                    title="Save override" (click)="saveEdit(row)">
              <i class="fa fa-check"></i>
            </button>
            <button type="button" class="vote-edit-btn vote-edit-btn--cancel" title="Cancel" (click)="cancelEdit()">
              <i class="fa fa-times"></i>
            </button>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
